export enum UsersFormFields {
  name = 'name',
  email = 'email',
  username = 'username',
  userType = 'userType',
  refCustomer = 'refCustomer'
}
